export const REGEX = {
  // Email regex  /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
  EMAIL_REGEX:
    /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,

  // Regex that accepts only digits
  ONLY_DIGITS_REGEX: /^[0-9]*$/,

  // Phone number
  PHONE_NO_REGEX: /^[7896]\d{9}$/, // /^\d{10}$/,

  // Regex that matches the entire string only if it contains only digits and at least one digit.
  OTP_STRING_REGEX: /^\d+$/,

  // Regex that accepts only alphabets in both small and capital case and space
  ONLY_ALPHABETS_REGEX: /^[a-zA-Z ]{2,50}$/,

  // Regex that accepts single word of alphabets in both small and capital case, without space
  SINGLE_WORD_REGEX: /^[A-Za-z]+$/,

  // Password regex
  PASSWORD_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;:'",.<>?/`~.]{6,32}$/,

  // Regex that accepts only alphabets in both small and capital case and space
  NAME_REGEX:  /^[a-zA-Z]{2,}(?:\s+[a-zA-Z]+)*$/,
};

export const ALLOWED_ROLES = ["TRAINEE"];

export const OTP_TIMER = 60; //300;

export const LOGIN_TYPE = {
  1: "EMAIL_PASSWORD",
  2: "MOBILE_PASSWORD",
  3: "EMAIL_OTP",
  4: "MOBILE_OTP",
};
